export default "__VITE_ASSET__ClrymvL5__"